import alternative_instagramIcon from '../../../../static/images/instagram_light.svg'
import alternative_facebookIcon from '../../../../static/images/facebook_light.svg'
import alternative_tripAdvisorIcon from '../../../../static/images/tripadvisor_light.svg'
import alternative_planneLogo from '../../../../static/images/planne_light.svg'
import alternative_twitterIcon from '../../../../static/images/twitter_light.svg'
import alternative_tiktokIcon from '../../../../static/images/tiktok_light.svg'
import alternative_youtubeLogo from '../../../../static/images/youtube_light.svg'

import default_instagramIcon from '../../../../static/images/instagram_dark.svg'
import default_facebookIcon from '../../../../static/images/facebook_dark.svg'
import default_tripAdvisorIcon from '../../../../static/images/tripadvisor_dark.svg'
import default_planneLogo from '../../../../static/images/planne_dark.svg'
import default_twitterIcon from '../../../../static/images/twitter_dark.svg'
import default_tiktokIcon from '../../../../static/images/tiktok_dark.svg'
import default_youtubeLogo from '../../../../static/images/youtube_dark.svg'

export const socialMediaIcons = (footerDisplay?: string) => {

    const icons: Icons = {
        default: {
            instagramIcon: default_instagramIcon,
            facebookIcon: default_facebookIcon,
            tripAdvisorIcon: default_tripAdvisorIcon,
            planneLogoIcon: default_planneLogo,
            twitterIcon: default_twitterIcon,
            tiktokIcon: default_tiktokIcon,
            youtubeIcon: default_youtubeLogo,
        },

        alternative: {
            instagramIcon: alternative_instagramIcon,
            facebookIcon: alternative_facebookIcon,
            tripAdvisorIcon: alternative_tripAdvisorIcon,
            planneLogoIcon: alternative_planneLogo,
            twitterIcon: alternative_twitterIcon,
            tiktokIcon: alternative_tiktokIcon,
            youtubeIcon: alternative_youtubeLogo,
        }
    }

    return footerDisplay ? icons[footerDisplay] : icons['default']
}

interface Icons{
    [key: string]: {
        instagramIcon: string;
        facebookIcon: string;
        tripAdvisorIcon: string;
        planneLogoIcon: string;
        twitterIcon: string;
        tiktokIcon: string;
        youtubeIcon: string;
    }
}